import React from 'react'
import Cont from '../Cont/Cont'
import Footer from '../Footer/Footer'
import Header from '../Header'

const Contact = () => {
  return (
    <div>
      <Header />
      <Cont />
      <Footer />
    </div>
  )
}

export default Contact